import { render, staticRenderFns } from "./Behandelingen.vue?vue&type=template&id=02431977"
import script from "./Behandelingen.vue?vue&type=script&lang=ts"
export * from "./Behandelingen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports